/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-06-24 10:01:00
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-06-24 10:29:42
 * @FilePath: \new_typhoonmap\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import wacth from '../views/wacth.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'wacth',
    component: wacth
  },
 
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
